import { render, staticRenderFns } from "./PurchaseOrdersTable.vue?vue&type=template&id=40791c89&scoped=true&"
import script from "./PurchaseOrdersTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrdersTable.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrdersTable.vue?vue&type=style&index=0&id=40791c89&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40791c89",
  null
  
)

export default component.exports